import { useContextState } from '../../../../../../../hooks/theme'
import { SxProps, Theme } from '@mui/system'

export const getFilterStyles = () => {
  const { colors: color } = useContextState()

  const filterDrawerTitle: SxProps<Theme> = {
    fontSize: '20px',
    fontWeight: 600,
    color: color.color13,
    mb: '20px',
  }

  const filterSectionTitle: SxProps<Theme> = {
    fontSize: '14px',
    fontWeight: 600,
    color: color.color13,
    mb: '20px',
  }

  const filterPeriodRow: SxProps<Theme> = {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    mb: '20px',
  }

  const filterField: SxProps<Theme> = {
    flex: 1,
    minWidth: '180px',
  }

  const filterButtonContainer: SxProps<Theme> = {
    display: 'flex', 
    justifyContent: 'flex-start',
    alignItems: 'center',
    mt: '24px'
  }

  const filterApplyButton: SxProps<Theme> = {
    fontSize: '16px',
    fontWeight: 500,
    borderRadius: '8px',
    padding: '5px 20px',
    backgroundColor: color.color16,
    color: color.color5,
    '&:hover': {
      backgroundColor: `${color.color16}dd`,
    },
  }

  return {
    filterDrawerTitle,
    filterSectionTitle,
    filterPeriodRow,
    filterField,
    filterButtonContainer,
    filterApplyButton,
  }
}
